<template src="./goodsImport.html"></template>

<script>
import VueResizable from 'vue-resizable'
import goodsTopMenu from '../components/topMenu';
import productLang from "../../../constants/goods";
export default {
  name: "GoodsImport",
  components: {
    VueResizable,
    goodsTopMenu
  },
  data() {
    return {
      file: null,
      ignoreFirstRow: 'yes',
      showRow: 10,
      items: [],
      isLoad: false,
      isImporting: false,
      cellDetailText: '',
      cellDetailLink: '',
      affiliationField: {},
      fileName: '',
      lanList: null,
      selectedLan: 'ru',
      fullOptionsList: ['id', 'name', 'articleAlias', 'brand', 'pdfs_1', 'pdfs_2', 'pdfs_3', 'pdfs_4', 'photos', 'category',
      'parentName', 'parentStatus', 'seoFlag', 'siteModels-modelId', 'siteArticleId', 'characteristic', 'weight',
        'template_description', 'dimension', 'dimension_type', 'description', 'donor_name', 'donor_link', 'type', 'link',
        'tags', 'search_query', 'price', 'priceMin', 'priceRu', 'priceRuMin', 'currency', 'customs_number', 'EAN',
        'additional_1', 'additional_2', 'additional_3', 'additional_4', 'additional_5', 'additional_6', 'additional_7',
        'additional_8', 'additional_9', 'additional_10', 'old_article', 'short_description', 'garbage_1', 'garbage_2',
        'uniqueCharacteristics', 'is_online', 'is_shop', 'availabilityDe', 'availabilityRu', 'isPublished'],
      fullOptionsList1: [
        {value: 'id', text: productLang.id},
        {value: 'name', text: 'Название'},
        {value: 'articleAlias', text: 'Артикль'},
        {value: 'brand', text: 'Бренд'},
        {value: 'pdfs_1', text: 'Документ 1'},
        {value: 'pdfs_2', text: 'Документ 2'},
        {value: 'pdfs_3', text: 'Документ 3'},
        {value: 'pdfs_4', text: 'Документ 4'},
        {value: 'photos', text: 'Картинки'},
        {value: 'category', text: 'Категория'},

        {value: 'parentName', text: 'Родитель'},
        {value: 'parentStatus', text: 'Статус родства'},
        {value: 'seoFlag', text: 'SEO флаг'},
        {value: 'siteModels-modelId', text: 'id модели из сайта'},
        {value: 'siteArticleId', text: 'id артикула из сайта'},

        {value: 'characteristic', text: 'Характеристика'},
        {value: 'weight', text: productLang.weight},
        {value: 'template_description', text: 'Шаблонное описание'},
        {value: 'dimension', text: 'Размерность(значение)'},
        {value: 'dimension_type', text: 'Размерность(тип)'},

        {value: 'description', text: 'Описание'},
        {value: 'donor_name', text: 'Донор:название'},
        {value: 'donor_link', text: 'Донор:ссылка'},
        {value: 'type', text: 'Тип'},
        {value: 'link', text: 'Ссылка на товар'},
        {value: 'tags', text: 'Теги'},
        {value: 'search_query', text: 'Поисковый запрос'},

        {value: 'price', text: productLang.price},
        {value: 'priceMin', text: 'Мин. цена'},
        {value: 'priceRu', text: 'Цена (ru)'},
        {value: 'priceRuMin', text: 'Мин. цена (ru)'},
        {value: 'currency', text: 'Валюта(EUR)'},
        {value: 'customs_number', text: 'Таможенного номера'},
        {value: 'EAN', text: 'EAN'},

        {value: 'additional_1', text: productLang.additional_1},
        {value: 'additional_2', text: productLang.additional_2},
        {value: 'additional_3', text: productLang.additional_3},
        {value: 'additional_4', text: productLang.additional_4},
        {value: 'additional_5', text: productLang.additional_5},
        {value: 'additional_6', text: productLang.additional_6},
        {value: 'additional_7', text: productLang.additional_7},
        {value: 'additional_8', text: productLang.additional_8},
        {value: 'additional_9', text: productLang.additional_9},
        {value: 'additional_10', text: productLang.additional_10},
        {value: 'old_article', text: 'Старый артикул'},
        {value: 'short_description', text: 'Краткое описание'},
        {value: 'garbage_1', text: 'Помойка1'},
        {value: 'garbage_2', text: 'Помойка2'},
        {value: 'uniqueDescriptions', text: 'Уник. описания'},
        {value: 'uniqueCharacteristics', text: 'Уник. характеристики'},
        {value: 'is_online', text: 'Online'},
        {value: 'is_shop', text: 'Shop'},
      ],
      //activeOptionsList: [],
      importErrorMessage: '',
      importErrorValue: '',
      importId: false,
      errorCounter: false,
      errorPercent: false,
      selectedCall: false,
      inputBrand: '',
      windowHeight: false,
      mainTableTop: false,
      isImportCancel: false,
      isApplyingImport: false,
      errorText: '',
      additionalCommentList: {},
      currentCommentEdit: false,
    }
  },

  methods: {
    getFieldName: function (value) {
      return productLang[value]
    },
    notEmptyObject: function (someObject) {
      return Object.keys(someObject).length
    },
    formSubmit: function (event) {
      if (event) {
        event.preventDefault()
      }
      return false;
    },
    clearSelected: function (key) {
      this.$delete(this.affiliationField, key);
    },
    showCellContent: function (text) {
      // show detail
      this.cellDetailLink = '';
      this.cellDetailText = '';
      if (text.indexOf('http') !== -1) {
        this.cellDetailLink = text;
      } else {
        this.cellDetailText = text;
      }

      setTimeout(this.windowResize, 1);
    },
    markCell: function (event) {
      // toggle focus of cell
      const textEl = this.$refs.mainTable.$el;
      const selectedEl = textEl.querySelector('.selectedCall');
      if (selectedEl != null) {
        selectedEl.classList.remove('selectedCall');
      }
      event.target.classList.add('selectedCall');
    },
    isAssign: function (value) {
      for (let key in this.affiliationField) {
        if (this.affiliationField[key] == value) {
          return true;
        }
      }
      return false;
    },
    goodsImport: function () {

      if (this.selectedLan == null) return;

      // check isset require data
      if (
          !this.isAssign('id') && (
            (!this.isAssign('brand') && this.inputBrand == '')
            || (!this.isAssign('name') && !this.isAssign('articleAlias'))
          )
      ) {
        this.$bvModal.show('emptyRequireData');
        return;
      }
      // fill data - prepare to send
      let formData = new FormData();
      formData.append('inputBrand', this.inputBrand);
      formData.append('selectedLan', this.selectedLan);
      formData.append('fileName', this.fileName);
      formData.append('shortFileName', this.file.name);
      formData.append('affiliationField', JSON.stringify(this.affiliationField));
      formData.append('ignoreFirstRow', (this.ignoreFirstRow == 'yes' ? 1 : 0));
      formData.append('additionalCommentList', JSON.stringify(this.additionalCommentList));

      var th = this;
      this.isImporting = true;
      this.$store.dispatch('SEND_POST', {
        url: '/goods-import/import',
        parameter: formData,
        config: {
          timeout: 60 * 15 * 1000
        },
        th: th,
        getResponse: () => {
          th.isImporting = false;
        },
        getSuccessResponse: (data) => {
          if (data == 7) {
            console.log(data);
          }
          th.clearMainTable();
          th.fileName = '';
          th.affiliationField = {};
        }
      });
    },
    clearMainTable: function () {
      this.items = [];
      this.cellDetailLink = false;
      this.cellDetailText = false;
      this.file = null;
      this.additionalCommentList = {};
      this.currentCommentEdit = false;
    },
    loadFile: function () {
      if (this.file == null) {
        return;
      }
      let formData = new FormData();
      console.log(this.file);
      formData.append('showRow', this.showRow);
      formData.append('ignoreFirstRow', (this.ignoreFirstRow == 'yes' ? 1 : 0));
      formData.append('file', this.file);

      var th = this;
      this.isLoad = true;
      this.$store.dispatch('SEND_POST', {
        url: '/goods-import/upload-file',
        parameter: formData,
        config: {
          timeout: 60 * 3 * 1000,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        },
        th: th,
        getResponse: () => {
          th.isLoad = false;
          th.$refs.audioImportEnd.play();
        },
        getSuccessResponse: (responseData) => {
          th.items = responseData.fileData;
          th.lanList = responseData.lanList;
          th.fileName = responseData.fileName;
        }
      });
    },
    updateList: function () {
      if (this.items.length == 0) {
        return;
      }
      let formData = new FormData();
      formData.append('showRow', this.showRow);
      formData.append('ignoreFirstRow', (this.ignoreFirstRow == 'yes' ? 1 : 0));
      formData.append('fileName', this.fileName);

      var th = this;
      this.isLoad = true;
      this.$store.dispatch('SEND_POST', {
        url: '/goods-import/get-list',
        parameter: formData,
        th: th,
        getResponse: () => {
          th.isLoad = false;
        },
        getSuccessResponse: (responseData) => {
          th.items = responseData.fileData;
        },
        showSuccessMessage: false
      });
    },
    windowResize: function () {
      this.windowHeight = window.innerHeight;
      this.setMainTableTop();
    },
    setMainTableTop: function () {
      let rect = this.$refs.mainTable.$el.getBoundingClientRect();
      this.mainTableTop = rect.top;
    },
    addComment: function (fieldName) {
      this.currentCommentEdit = fieldName;
      this.$bvModal.show('additionalComment');
    },
    getCommentStatus: function (fieldName) {
      return this.additionalCommentList[this.affiliationField[fieldName]] != undefined ? 'outline-primary' : 'success';
    }
  },

  // ============================__COMPUTED__============================

  computed: {
    mainTableWidth: function () {
      return this.$refs.mainTable.$el.clientWidth + 15;
    },
    getOptionsList: function () {
      return this.fullOptionsList.filter( option => {
        return !Object.values(this.affiliationField).includes(option)
      }).map(o=>({text: productLang[o], value: o}))
    },
    getTableData: function () {
      return this.items;
    },
    getTableFields: function () {
      if (this.items.length == 0) {
        return [];
      }

      let fields = [];
      fields.push('index');
      for (let i = 0; i < this.items[0].length; i++) {
        fields.push(i.toString(10));
      }

      return fields;
    },
    getTableHeight: function () {
      return (this.windowHeight - this.mainTableTop - 10) + 'px';
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('product') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.windowResize();
    this.setMainTableTop();
  },
  created() {
    //this.activeOptionsList = this.fullOptionsList
    window.addEventListener("resize", this.windowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },

}
</script>

<style scoped>
.t-head-cell {
  font-size: 1rem;
}

#showRow {
  width: 70px;
}

.upload-box {
  padding-top: 20px;
  text-align: left;
}

.goods-import-panel .form-control-file {
  width: auto;
}

.t-cell {
  overflow: hidden;
  display: block;
  height: 23px;
  font-size: 0.9rem;
  padding: 0 0.2rem;
}

.resizable-component {
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #e9ecef;
  padding: 0.5rem;
  text-align: left;
  font-size: 0.9rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin: 0;
}

.cell-detail.resizable-content {
  background-color: #e9ecef;
}

.cell-cursor {
  cursor: cell;
  padding: 1px;
}

.cell-cursor:hover {
  border: solid 1px grey;
  padding: 0;
}

.cell-cursor.selectedCall {
  border: solid 2px #007bff;
  padding: 0;
}

.name-coll-selected {
  font-size: 0.8rem;
  display: block;
}

.common-head-cell {
  height: 4rem;
  display: block;
  text-align: center;
  padding: 0 0.2rem;
}

.index-call {
  vertical-align: middle;
}

.t-head-cell.number-head {
  display: block;
}

.text-align-left {
  text-align: left;
}

.text-align-right {
  text-align: right;
}

.resizable-content {
  height: 100%;
  width: 100%;
  background-color: aqua;
}

.b-table-sticky-header, .table-responsive, [class*="table-responsive-"] {
  margin-bottom: 0;
}

.apply-cancel-import {
  width: 150px;
}

.but-add-comment {
  padding: 0.25rem;
  line-height: 0.8;
}

</style>
<style>
.goods-import thead th {
  height: 4.5rem;
}

.goods-import .error-table thead th {
  height: 2rem !important;
}

.goods-import .b-table-sticky-header > .table.b-table > thead > tr > th {
  top: -1px !important;
}

.goods-import .goods-import tr th:first-child {
  width: 5%;
}

.goods-import .table th, .goods-import .table td {
  padding: 0;
  vertical-align: middle;
}

.goods-import html {
  overflow-x: hidden;
}
</style>